const ADMIN_NO_CACHE_QUERY_OPTIONS = {
  gcTime: 0,
  refetchOnMount: "always",
  refetchOnReconnect: "always",
  refetchOnWindowFocus: "always",
  staleTime: 0,
} as const;

export function adminNoCacheQueryOptions<TOptions extends object>(queryOptions: TOptions) {
  return {
    ...queryOptions,
    ...ADMIN_NO_CACHE_QUERY_OPTIONS,
  };
}
